import React from 'react'
import { Icon } from '@driftt/tide-core-legacy'
import GateContainer from 'components/payments/Gates'

import SalesforceLeadEnrichmentIcon from './Icons/SalesforceLeadEnrichmentIcon'
import ConvoRevealIcon from './Icons/ConvoRevealIcon'
import LiveRevealIcon from './Icons/LiveRevealIcon'
import TargetingRevealIcon from './Icons/TargetingRevealIcon'

import './style.styl'

const UpgradeRibbon = () => (
  <span className="clearbit-reveal-upgrade-ribbon">
    Upgrade
  </span>
)

const TopPane = (props) => (
  <p className="clearbit-reveal-upgrade-description">
    {props.message}
    <Icon
      className="right-arrow"
      width={15}
      height={10}
      name="arrow-2-right"
    />
  </p>
)

const BottomPane = (props) => (
  <div className="clearbit-reveal-upgrade-view-widget">
    {props.icon}
  </div>)

const ClearbitRevealPreview = ({ title, message, icon }) => {

  return (<div className="clearbit-reveal-upgrade-view">
    <UpgradeRibbon/>
    <div className="clearbit-accordion-header">
      <div className="clearbit-accordion-header-top">
        <span className="clearbit-accordion-header-title">
          {title}
        </span>
      </div>
    </div>
    <div>
      <TopPane message={message}/>
      <div className="border-div"/>
      <BottomPane icon={icon}/>
    </div>
  </div>)
}

const Upgrade = ({ component, featureText, featurePlan, featureTag }) => {
  return (
    <GateContainer
      FallbackComponent={component}
      requiredGates={['NO_GATES']}
      useModal={true}
      modalText={featureText}
      modalPlan={featurePlan}
      feature={featureTag}
    />
  )
}

export const ClearbitRevealConvoPreview = () => {
  const convoTitle = 'Want to see company data here?'
  const message = 'Reveal full company data for anonymous site visitors in Live View, conversations, and playbook targeting with Drift\'s Pro Plan\n'
  const component = <ClearbitRevealPreview title={convoTitle} message={message} icon={<ConvoRevealIcon/>}/>
  return <Upgrade component={component} featureText="Company data in conversations" featurePlan="Pro" featureTag="clearbit-reveal-convo-view"/>
}

export const ClearbitRevealLivePreview = () => {
  const convoTitle = 'Want to see company data here?'
  const message = 'Reveal full company data for anonymous site visitors in Live View, conversations, and playbook targeting with Drift\'s Company Plan\n'
  const component = <ClearbitRevealPreview title={convoTitle} message={message} icon={<LiveRevealIcon/>}/>
  return <Upgrade component={component} featureText="Company data in Live" featurePlan="Company" featureTag="clearbit-reveal-live-view"/>

}

export const ClearbitRevealTargetingPreview = () => {
  const convoTitle = 'Want to target based on enriched company data?'
  const message = 'Target playbooks based on Clearbit company data like Alexa Ranking, Revenue, Amount Raised, and more with Drift’s Company Plan.'
  const component = <ClearbitRevealPreview title={convoTitle} message={message} icon={<TargetingRevealIcon/>}/>
  return <Upgrade component={component} featureText="Clearbit Firmographics" featurePlan="Company" featureTag="clearbit-reveal-firmographics-view"/>
}

export default ClearbitRevealPreview



// WEBPACK FOOTER //
// ./src/scripts/components/ClearbitRevealPreview/index.js